import React from 'react';

/** Frosted mesh wash — no visible blob circles; tints bleed for glass blur. */
export function CalendarAnimatedBg() {
  return (
    <div className="calendar-animated-bg" aria-hidden>
      <div className="calendar-animated-bg__wash" />
      <div className="calendar-animated-bg__veil" aria-hidden />
      <div className="calendar-animated-bg__grain" aria-hidden />
    </div>
  );
}
